/* tslint:disable */
require('./FieldFileTypeRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_0846ad4a',
  relative: 'relative_0846ad4a',
  fabricIcon: 'fabricIcon_0846ad4a',
  container: 'container_0846ad4a',
  folder: 'folder_0846ad4a',
};

export default styles;
/* tslint:enable */